"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../../../theme");
var SPACING = {
    tight: 8,
    normal: 16,
    loose: 24,
};
exports.Wrapper = styled_components_1.default.div.attrs({
    'data-component-name': 'Form.Rows',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n\n  @media ", " {\n    display: ", ";\n  }\n\n  @media ", " {\n    display: ", ";\n  }\n\n  > * {\n    &:not(:last-child) {\n      margin-bottom: ", "px;\n    }\n\n    ", "\n\n    @media ", " {\n      ", "\n    }\n\n    @media ", " {\n      ", "\n    }\n  }\n"], ["\n  display: ",
    ";\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n\n  @media ", " {\n    display: ",
    ";\n  }\n\n  @media ", " {\n    display: ",
    ";\n  }\n\n  > * {\n    &:not(:last-child) {\n      margin-bottom: ", "px;\n    }\n\n    ",
    "\n\n    @media ", " {\n      ",
    "\n    }\n\n    @media ", " {\n      ",
    "\n    }\n  }\n"])), function (_a) {
    var split = _a.split;
    if ((split === null || split === void 0 ? void 0 : split.small) === 'full') {
        return 'block';
    }
    return Array.isArray(split === null || split === void 0 ? void 0 : split.small) ? 'flex' : 'block';
}, theme_1.theme.breakpoints.medium, function (_a) {
    var split = _a.split;
    if ((split === null || split === void 0 ? void 0 : split.medium) === 'full') {
        return 'block';
    }
    return Array.isArray(split === null || split === void 0 ? void 0 : split.medium) ? 'flex' : 'block';
}, theme_1.theme.breakpoints.large, function (_a) {
    var split = _a.split;
    if ((split === null || split === void 0 ? void 0 : split.large) === 'full') {
        return 'block';
    }
    return Array.isArray(split === null || split === void 0 ? void 0 : split.large) ? 'flex' : 'block';
}, function (_a) {
    var _b = _a.fit, fit = _b === void 0 ? 'normal' : _b;
    return SPACING[fit];
}, function (_a) {
    var _b;
    var split = _a.split, _c = _a.fit, fit = _c === void 0 ? 'normal' : _c;
    if ((split === null || split === void 0 ? void 0 : split.small) === 'full') {
        return "width: 100%;";
    }
    return (_b = split === null || split === void 0 ? void 0 : split.small) === null || _b === void 0 ? void 0 : _b.map(function (ratio, i) { return "\n        &:nth-child(" + (i + 1) + ") {\n          flex-shrink: 1;\n          width: calc(" + ratio + "% - " + SPACING[fit] / 2 + "px);\n          margin-left: 0!important;\n          margin-right: 0!important;\n        }\n      "; });
}, theme_1.theme.breakpoints.medium, function (_a) {
    var _b;
    var split = _a.split, _c = _a.fit, fit = _c === void 0 ? 'normal' : _c;
    if ((split === null || split === void 0 ? void 0 : split.medium) === 'full') {
        return "width: 100%;";
    }
    return (_b = split === null || split === void 0 ? void 0 : split.medium) === null || _b === void 0 ? void 0 : _b.map(function (ratio, i) { return "\n        &:nth-child(" + (i + 1) + ") {\n          flex-shrink: 1;\n          width: calc(" + ratio + "% - " + SPACING[fit] / 2 + "px);\n          margin-left: 0!important;\n          margin-right: 0!important;\n        }\n      "; });
}, theme_1.theme.breakpoints.large, function (_a) {
    var _b;
    var split = _a.split, _c = _a.fit, fit = _c === void 0 ? 'normal' : _c;
    if ((split === null || split === void 0 ? void 0 : split.large) === 'full') {
        return "width: 100%;";
    }
    return (_b = split === null || split === void 0 ? void 0 : split.large) === null || _b === void 0 ? void 0 : _b.map(function (ratio, i) { return "\n        &:nth-child(" + (i + 1) + ") {\n          flex-shrink: 1;\n          width: calc(" + ratio + "% - " + SPACING[fit] / 2 + "px);\n          margin-left: 0!important;\n          margin-right: 0!important;\n        }\n      "; });
});
var templateObject_1;
